import React from 'react';

class SatisfactionMeterReport extends React.Component {
	constructor(props){
		super(props);
	}
	render(){
		const p = this.props;
		return(
			<div className="app-inner-content">
				{"TODO: Satisfaction Meter Report"}
			</div>
		);
	}
};

export default SatisfactionMeterReport;